import { Button, Modal } from 'antd'
import type { ButtonProps, ModalProps } from 'antd'
import type { ReactNode } from 'react'

type BaseDialogProps = Omit<ModalProps, 'open' | 'onCancel' | 'onOk' | 'title' | 'footer'> & {
	open: boolean
	title?: ReactNode
	onClose: () => void
	onConfirm?: () => void
	children: ReactNode
	footer?: ModalProps['footer']
	showDefaultActions?: boolean
	confirmText?: ReactNode
	cancelText?: ReactNode
	confirmButtonProps?: ButtonProps
	cancelButtonProps?: ButtonProps
}

export const BaseDialog = ({
	open,
	title,
	onClose,
	onConfirm,
	children,
	footer,
	showDefaultActions = true,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	confirmButtonProps,
	cancelButtonProps,
	centered = true,
	destroyOnClose = true,
	...modalProps
}: BaseDialogProps) => {
	const defaultFooter = showDefaultActions
		? [
				<Button key="cancel" onClick={onClose} {...cancelButtonProps}>
					{cancelText}
				</Button>,
				<Button key="confirm" type="primary" onClick={onConfirm} {...confirmButtonProps}>
					{confirmText}
				</Button>,
			]
		: null

	return (
		<Modal
			open={open}
			title={title}
			centered={centered}
			destroyOnClose={destroyOnClose}
			onCancel={onClose}
			onOk={onConfirm}
			footer={footer === undefined ? defaultFooter : footer}
			{...modalProps}
		>
			{children}
		</Modal>
	)
}
